import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FunctionalMainGroupEditorV2.html?raw';

import MainCatalogsEditorBaseV2 from '../../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../../_loadingHelpers/MainCatalogTypes";

class FunctionalMainGroupEditorV2 extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.FunctionalMainGroup;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FunctionalMainGroupEditorV2);